import React, { memo, useMemo } from 'react';
import { Button } from '@cognitiv/cyprus-ui';
import { AdvancedFilterButtonsProps } from 'ducks/types/prop-types';
import { useSwitchTheme } from 'hooks/useSwitchTheme';
import { getCheckBoxTheme } from 'utils/modal/helpers';

import cn from 'modals/advanced-filtering/components/AdvancedFilter.module.scss';

const AdvancedFilterButtonsBase = ({ onSetFilter, onClearFilter }: AdvancedFilterButtonsProps) => {
  const { theme } = useSwitchTheme();
  const check_box_theme = useMemo(() => getCheckBoxTheme(theme), [theme]);

  return (
    <div className={cn.advFilterButtons}>
      <Button onClick={onSetFilter} variant="blue" margin="40px 0px 0px 0px" width="100%" theme={check_box_theme}>
        Set Custom Filter
      </Button>

      <Button
        onClick={onClearFilter}
        variant="blue"
        margin="20px 0px 0px 0px"
        width="100%"
        outline
        theme={{
          button_font_color: '#276ef1',
        }}
      >
        Clear Custom Filter
      </Button>
    </div>
  );
};

export const AdvancedFilterButtons = memo(AdvancedFilterButtonsBase);
